import Modal from "@/components/base/Modal";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// 자체 확인창 (alert/confirm 미사용)
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "삭제",
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} maxWidth="max-w-sm">
      <div className="p-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
            <i className="ri-error-warning-line text-xl" aria-hidden="true"></i>
          </span>
          <h2 className="font-heading text-base font-bold text-foreground-950">
            {title}
          </h2>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600">{message}</p>
        <div className="mt-6 flex gap-2">
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="flex-1 whitespace-nowrap rounded-md bg-accent-600 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-accent-700 disabled:opacity-60"
          >
            {busy ? "처리 중…" : confirmLabel}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 disabled:opacity-60"
          >
            취소
          </button>
        </div>
      </div>
    </Modal>
  );
}